import { Navigate } from 'react-router'

export default function () {
  return <Navigate to={'/inventories/locations'} replace />
}
